export default __webpack_public_path__ + "static/media/a021-viewmore.3a7eb8af.jpg";